import LanguageSwitcher from '@components/UI/LanguageSwitcher/LanguageSwitcher.component';
import { ROUTE_PATH } from '@shared/constants/route-path.enum';
import { useTranslationHelper } from '@shared/hooks/useTranslationsHelper';
import { selectInboxStatus } from '@shared/store/app/app.selectors';
import { MdcBadge, MdcBox, MdcGrid, MdcIcon, MdcIconButton } from 'ids-wc/dist/react/components';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

export const TopNavigationActions = () => {
  const { hasUnread } = useSelector(selectInboxStatus);

  const { t } = useTranslationHelper('notifications');

  return (
    <MdcGrid id="topNav" row justifyContent="between" alignItems="center" wrap="nowrap" className="py-3">
      <MdcGrid col="flex">
        <MdcBox display="flex" justifyContent="end" alignItems="center">
          <MdcBox className="mx-2">
            <LanguageSwitcher />
          </MdcBox>

          <Link to={`/${ROUTE_PATH.NOTIFICATIONS}`}>
            {hasUnread ? (
              <MdcBadge label="." variant="simple" severity="error" size="sm" placement="outer">
                <MdcIcon size="md" color="secondary" title="bell" icon="notifications" />
              </MdcBadge>
            ) : (
              <MdcIconButton size="md" color="secondary" title={t('notifications')} icon="notifications" />
            )}
          </Link>
        </MdcBox>
      </MdcGrid>
    </MdcGrid>
  );
};
